// extracted by mini-css-extract-plugin
export default {"AdSlotMail__mail":"bgf_a bhc_wj bhc_a bhc_q bhc_k","AdSlotMail__mail--notLoaded":"bgf_b bhc_ey bhc_bj bhc_wy","show-ad-not-loaded":"bgf_c","AdSlotMail__cta":"bgf_e"};